import { getEconomyPolicy, } from '@debbie/common/dist/economy/helpers/policy.js';
import { useMemo } from 'react';
import { useCreditor } from '../creditors/index.js';
import { h } from '../index.js';
import { useTenant } from '../tenant/index.js';
// Null until the case, its tenant and its creditor have loaded: the case's
// engine decides the calculation.
export const useEconomyPolicy = (singleCase) => {
    const tenant = useTenant();
    const creditorLoader = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoader) ? creditorLoader.data : null;
    return useMemo(() => tenant != null && creditor != null && singleCase != null
        ? getEconomyPolicy(tenant, creditor, singleCase.economyEngine)
        : null, [tenant, creditor, singleCase]);
};
//# sourceMappingURL=index.js.map